import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import ActionStatus from 'common/types/ActionStatus';
import ChsAddress from 'domain/types/ChsAddress';
import DraftApplication from 'domain/types/DraftApplication';
import { Button, Card, Spinner } from 'react-bootstrap';
import { ApplicationStep } from '../../domain/enums/ApplicationStep';
import Application from './components/Application';
import {
  IdentityDeniedAlert,
  IdentityNotUploadedAlert,
  MailingAddressNotCompleteAlert,
} from './NotAllowedAlerts';
import ReviewPage from './ReviewPage';

interface IApplyForRegistrationPresenter {
  //isPromptingShuol: boolean;
  isPromptingExistingApp: boolean;
  //onShuolProceed: () => void;
  onExistingClick: () => void;
  onResetClick: () => void;
  identity: {
    rejected: boolean;
    uploaded: boolean;
    loading: boolean;
  };
  data: DraftApplication;
  errors: string[];
  isReviewing: boolean;
  loading: boolean;
  submitStatus: ActionStatus;
  profileAddress: ChsAddress;
  onSubmit: () => Promise<void>;
  onClearApplication: () => void;
  onReturnToDashboard: () => void;
  onReviewClick: () => void;
  onBackToApplicationClick: () => void;
  defaultStep: ApplicationStep;
}

const ApplyForRegistrationPresenter = (
  props: IApplyForRegistrationPresenter
) => {
  if (props.isReviewing) {
    return (
      <ReviewPage
        onResetClick={props.onResetClick}
        data={props.data}
        errors={props.errors}
        onSubmit={props.onSubmit}
        onReturnToDashboard={props.onReturnToDashboard}
        submitStatus={props.submitStatus}
        onBackToApplicationClick={props.onBackToApplicationClick}
      />
    );
  }

  const restrictionAlerts: JSX.Element[] = [];

  function addRestrictionAlert(el: JSX.Element) {
    restrictionAlerts.push(el);
  }

  if (!props.identity.uploaded) {
    addRestrictionAlert(<IdentityNotUploadedAlert />);
  }
  if (props.identity.rejected) {
    addRestrictionAlert(<IdentityDeniedAlert />);
  }
  if (!props.profileAddress) {
    addRestrictionAlert(<MailingAddressNotCompleteAlert />);
  }

  // If there are any restrictions, show them and disallow user from applying
  if (restrictionAlerts.length > 0) {
    return <>{restrictionAlerts.map((a) => a)}</>;
  }

  if (props.loading || props.identity.loading) {
    return <Spinner animation='border' />;
  }

  return (
    <Page
      template={
        props.isPromptingExistingApp
          ? PageTemplates.truncated
          : PageTemplates.fullWidth
      }
    >
      <h2 className='mb-3'>Short term rental registration application</h2>
      {props.isPromptingExistingApp ? (
        <Card>
          <Card.Header>
            <h3>Existing application found</h3>
          </Card.Header>
          <Card.Body>
            <p>
              An existing in-progress application was found. Would you like to
              continue working on this application or start a new application?
            </p>
            <div className='d-flex mt-5'>
              <Button
                className='mr-auto'
                variant='outline-warning'
                onClick={props.onResetClick}
              >
                Start new application
              </Button>
              <Button
                variant='primary'
                className='ml-5'
                onClick={props.onExistingClick}
              >
                Continue existing
              </Button>
            </div>
          </Card.Body>
        </Card>
      ) : (
        <Application
          onReviewClick={props.onReviewClick}
          onClearAllSteps={props.onClearApplication}
          defaultStep={props.defaultStep}
        />
      )}
    </Page>
  );
};

export default ApplyForRegistrationPresenter;
